import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=aec56a18&scoped=true&lang=html&"
import script from "./Chapter.vue?vue&type=script&lang=ts&"
export * from "./Chapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec56a18",
  null
  
)

export default component.exports